import React, { Component } from "react"
import Datetime from "react-datetime"
import Text from "components/text"
import moment from "moment"

import "react-datetime/css/react-datetime.css"
import "./index.scss"

class FormDatePicker extends Component {
  clearDate = () => {
    this.props.handleClearDate()
  }

  handleKeyDown = (e, closeCalendar) => {
    if (e.key === "Backspace" || e.key === "Delete") {
      e.preventDefault()
      this.clearDate()
      // Close the calendar
      closeCalendar()
    }
  }

  renderInput(props, dateValue, closeCalendar) {
    const { dateFormat = "MMMM D, YYYY" } = this.props

    const updatedDateValue = moment(dateValue).isValid()
      ? moment(dateValue).format(dateFormat)
      : ""
    return (
      <div className="input-container">
        <input
          {...props}
          value={updatedDateValue}
          onKeyDown={(e) => {
            this.handleKeyDown(e, closeCalendar)
            props.onKeyDown(e)
          }}
        />
        <button
          type="button"
          onClick={() => this.clearDate()}
          className="clear-button"
        >
          <svg
            height="20"
            width="20"
            viewBox="0 0 20 20"
            aria-hidden="true"
            focusable="false"
            className="icon"
          >
            <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
          </svg>
        </button>
      </div>
    )
  }

  render() {
    const {
      name,
      label,
      value,
      dateFormat,
      error,
      handleChangeDate,
      handleClearDate,
      horizontal,
      required,
      hint,
      ...props
    } = this.props

    const dateValue = moment(value).isValid() ? moment(value) : ""

    const { iid } = props
    const inputProps = {
      readOnly: true,
    }

    return (
      <div
        className={`form-input datepicker ${
          horizontal ? "-horizontal" : "-vertical"
        }`}
      >
        <Text type="label" text={label + (required ? " *" : "")} />
        <Datetime
          name={name}
          value={dateValue}
          timeFormat={false}
          inputProps={inputProps}
          onChange={handleChangeDate}
          instanceId={iid}
          closeOnSelect={true}
          closeOnTab={true}
          renderInput={(props, closeCalendar) =>
            this.renderInput(props, dateValue, closeCalendar)
          }
        />
        {hint ? <p className="form-hint">{hint}</p> : null}
        {error ? <p className="error-message">{`* ${error}`}</p> : null}
      </div>
    )
  }
}

export default FormDatePicker
